module.exports = __webpack_public_path__ + "static/media/SmartShop_3-320w.4af9edba.png";